import { QuestionnaireItemComponent } from '../../../unsw-fhir/Questionnaire';

export const QuestionnaireItemValidator =
  (item: QuestionnaireItemComponent) => (value?: any) => {
    if (item.required && !value) return 'This field is required';

    return undefined;
  };
